<template>
  <Modal
    :title="
      edit
        ? $t('auxiliaryCoolingEquipment.edit')
        : $t('auxiliaryCoolingEquipment.add')
    "
    hide-footer
    :value="value"
    :lg="form.id ? true : false"
    :okText="
      edit
        ? $t('auxiliaryCoolingEquipment.edit')
        : $t('auxiliaryCoolingEquipment.add')
    "
    @input="$emit('input', $event)"
  >
    <div class="container-fluid">
      <div class="row">
        <div class="es-xs-12" :class="{ 'es-md-6': form.id }">
          <div class="form-container">
            <BaseInput
              block
              size="sm"
              input-id="title"
              :label="$t('auxiliaryCoolingEquipment.equipment')"
              v-model="formData.title"
              :mandotary="true"
            />

            <BaseInput
              block
              size="sm"
              input-id="brand"
              :label="$t('auxiliaryCoolingEquipment.brand')"
              v-model="formData.brand"
              :mandotary="true"
            />

            <BaseInput
              block
              size="sm"
              input-id="model"
              :label="$t('auxiliaryCoolingEquipment.model')"
              v-model="formData.model"
              :mandotary="true"
            />

            <BaseInput
              block
              size="sm"
              input-id="chip"
              :label="$t('auxiliaryCoolingEquipment.chip')"
              v-model="formData.chip"
              :mandotary="true"
            />

            <BaseInput
              block
              size="sm"
              input-id="width"
              :label="$t('auxiliaryCoolingEquipment.width')"
              type="number"
              step="0.01"
              v-model="formData.width"
              :mandotary="true"
            />

            <BaseInput
              block
              size="sm"
              input-id="height"
              :label="$t('auxiliaryCoolingEquipment.height')"
              type="number"
              step="0.01"
              v-model="formData.height"
              :mandotary="true"
            />

            <BaseInput
              block
              size="sm"
              input-id="depth"
              :label="$t('auxiliaryCoolingEquipment.depth')"
              type="number"
              step="0.01"
              v-model="formData.depth"
              :mandotary="true"
            />

            <div class="u-margin-top">
              <img
                :src="getImage(formData.imagePath)"
                alt="image"
                width="75"
                class="u-radius-g"
              />
              <Button
                variant="primary"
                class="u-margin-left-small"
                @click="$refs.image.click()"
              >
                <i class="icofont-upload"></i> {{ $t("common.upload") }}
              </Button>
            </div>

            <input
              block
              input-id="image"
              :label="$t('auxiliaryCoolingEquipment.image')"
              type="file"
              class="u-display-none"
              ref="image"
              accept="image/*"
              @change="handleImageUpload"
              :mandotary="true"
            />
            <hr />
            <div class="u-margin-top u-display-flex u-justify-content-flex-end">
              <Button
                @click="$emit('input', false)"
                class="u-margin-right-xsmall"
              >
                {{ $t("common.close") }}
              </Button>
              <Button variant="primary" @click="save" v-if="!edit">
                {{ $t("auxiliaryCoolingEquipment.add") }}
              </Button>
              <Button variant="primary" @click="update" v-else>
                {{ $t("auxiliaryCoolingEquipment.edit") }}
              </Button>
            </div>
          </div>
        </div>
        <div class="es-xs-12" :class="{ 'es-md-6': form.id }" v-if="form.id">
          <techinal-drawing
            class="u-padding-xsmall"
            :auxiliaryCoolingEquipment="form"
          ></techinal-drawing>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Base/Modal.vue";
import BaseInput from "@/components/Base/Inputs/BaseInput.vue";
import Requests from "@/services/Requests";
import Button from "@/components/Base/Button.vue";
import $api from "@/services/Api";
import TechinalDrawing from "./TechinalDrawing.vue";

export default {
  components: {
    Modal,
    BaseInput,
    Button,
    TechinalDrawing,
  },
  props: {
    value: {
      default: false,
    },
    edit: {
      default: false,
      type: Boolean,
    },
    form: {
      default: () => ({
        id: null,
        brand: "",
        model: "",
        chip: "",
        width: null,
        height: null,
        depth: null,
        image: null,
      }),
    },
  },
  data() {
    return {
      formData: {
        title: "",
        brand: "",
        model: "",
        chip: "",
        width: null,
        height: null,
        depth: null,
        imagePath: null,
      },
      file: null,
      files: [
        { id: 1, name: "test.pdf", filePath: "test.pdf" },
        { id: 2, name: "test2.pdf", filePath: "test2.pdf" },
      ],
    };
  },
  watch: {
    value(value) {
      if (value) {
        this.checkProps();
      }
    },
  },
  methods: {
    getImage(image) {
      return $api.image(image);
    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.file = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.imagePath = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    validation(file) {
      console.log(
        Object.values(this.formData).every(
          (value) => value !== null && value !== ""
        ),
        file
      );

      return (
        Object.values(this.formData).every(
          (value) => value !== null && value !== ""
        ) && file
      );
    },
    async save(e, loading) {
      if (!this.validation(this.file ? true : false)) {
        this.$store.dispatch("SET_ACTION_MODAL", {
          status: true,
          message: this.$t("auxiliaryCoolingEquipment.fillAllFields"),
          variant: "danger",
          duration: 2500,
        });
        return;
      }

      const fd = new FormData();
      fd.append("title", this.formData.title);
      fd.append("brand", this.formData.brand);
      fd.append("model", this.formData.model);
      fd.append("chip", this.formData.chip);
      fd.append("width", this.formData.width);
      fd.append("height", this.formData.height);
      fd.append("depth", this.formData.depth);
      if (this.file) {
        fd.append("image", this.file);
      }

      loading(true);
      const response = await Requests.AuxiliaryCoolingEquipment.Create(fd);

      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          status: true,
          message: this.$t("auxiliaryCoolingEquipment.success"),
          variant: "success",
          duration: 2500,
        });
        this.$emit("refresh");
        this.$emit("input", false);
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    async update(e, loading) {
      if (!this.validation(true)) {
        this.$store.dispatch("SET_ACTION_MODAL", {
          status: true,
          message: this.$t("validation.fillAllFields"),
          variant: "danger",
          duration: 2500,
        });
        return;
      }

      const fd = new FormData();
      fd.append("title", this.formData.title);
      fd.append("brand", this.formData.brand);
      fd.append("model", this.formData.model);
      fd.append("chip", this.formData.chip);
      fd.append("width", this.formData.width);
      fd.append("height", this.formData.height);
      fd.append("depth", this.formData.depth);
      if (this.file) {
        fd.append("image", this.file);
      }

      loading(true);
      const response = await Requests.AuxiliaryCoolingEquipment.Update(fd, {
        params: { id: this.form.id },
      });

      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          status: true,
          message: this.$t("auxiliaryCoolingEquipment.success"),
          variant: "success",
          duration: 2500,
        });
        this.$emit("refresh");
        this.$emit("input", false);
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    checkProps() {
      if (this.edit) {
        this.formData = { ...this.form };
      }
    },
    viewFile(file) {
      window.open($api.image(file.filePath), "_blank");
    },
    removeFile(file) {
      this.files = this.files.filter((f) => f.id !== file.id);
    },
  },
  mounted() {
    this.checkProps();
  },
};
</script>
